// extracted by mini-css-extract-plugin
export default {"copy":"CopyToClipboard_copy__K52q1"};